import { nutrientColors } from "@omnia/shared/nutrition/colors";
import { INtrReqNutrients } from "../../../omnia";

export class NutrientVm {

    public static create(initial: INtrReqNutrients, closing: INtrReqNutrients, opening: INtrReqNutrients, key: string, rounding: number = 1): NutrientVm {

        let reqdNutrientKey = "Required" + key;

        let initialValue = opening[reqdNutrientKey] || 0;

        let closingValue = closing[reqdNutrientKey] || 0;
        let openingValue = opening[reqdNutrientKey] || 0;

        let value = Math.round(Math.abs(openingValue - closingValue) * rounding) / rounding;

        let totalRatio = !initialValue ? 0 : 100 - ((closingValue * 100) / initialValue);
        totalRatio = Math.max(0, Math.min(100, totalRatio));

        let currentRatio = !initialValue ? 0 : ((value * 100) / initialValue);
        currentRatio = Math.max(0, Math.min(100, currentRatio));

        let req = new NutrientVm();

        req.key = key;
        req.total = totalRatio;
        req.current = currentRatio;
        req.value = value;
        req.initValue = initialValue;
        req.overApplying = value > openingValue;
        req.requirementsLeft = openingValue;
        req.prevContrib = Math.round((initialValue - openingValue) * rounding) / rounding;

        return req;

    }

    public key: string;

    public total: number;

    public current: number;

    public value: number;

    public initValue: number;

    public overApplying: boolean;

    public requirementsLeft: number;

    public prevContrib: number;

    public getTotal(left: boolean) {
        return (left ? this.requirementsLeft : this.initValue);
    }

    public getBarStyle(left: boolean) {

        let nutrient = this.key;
        let value = this.current;
        let value2 = (left ? this.current : this.total);

        var color = nutrientColors[nutrient].baseColor;
        var backgroundColor = [182, 182, 182];

        var v = value > 0 ? Math.max(value, 25) : 0;
        var v2 = value2 > 0 ? Math.max(value2, 25) : 0;

        return {
            background: "linear-gradient(to right, rgb(" +
                color[0] + ", " + color[1] + ", " + color[2] + "), rgb(" +
                color[0] + ", " + color[1] + ", " + color[2] + ") " + v + "%, " +
                "rgb(" +
                backgroundColor[0] + ", " + backgroundColor[1] + ", " + backgroundColor[2] + ") " + v + "%, rgb(" +
                backgroundColor[0] + ", " + backgroundColor[1] + ", " + backgroundColor[2] + ") " + v2 + "%, " +
                "transparent " + v2 + "%)"
        };
    }

    public getCssClass() {

        let css = {
            overapplied: this.overApplying,
            "contrib-prev-plans": (this.prevContrib > 0)
        };

        return css;

    }

    public getTitle() {
        if (this.prevContrib > 0) {
            const units = "kg/ha";
            return `Contribution from previous plans: ${this.prevContrib} ${units}`;
        }
    }

}
